@if (!useSummaryView) {
  @if (!field.hidden) {
    <div class="flex flex-col w-full" animate.enter="fade-in">
      <div class="flex flex-row items-center w-full">
        @if (field.browserOpts.inLineWithCaption) {
          <mat-label class="mr-2 mb-4 font-medium">{{ field.label|
            localize }}
          </mat-label>
        }
        <mat-form-field class="w-full">
          <mat-label>{{ field.label | localize }}</mat-label>
          <mat-chip-grid #chipGrid class="p-2" [formControl]="field.control">
            @for (chip of field.control.value; track chip; let i = $index) {
              <mat-chip-row [value]="chip"
                [selectable]="false" [selected]="false" [removable]="!field.control.disabled"
                (removed)="removeChip(i)">
                {{ chipName(chip) }}
              </mat-chip-row>
            }
            <button class="ml-2" mat-stroked-button (click)="openCategoryTreeDialog()">{{
            'selectCategories' | transloco }}</button>
            <input [matChipInputFor]="chipGrid" [placeholder]="field.placeholder | localize"
              [matChipInputAddOnBlur]="true" [matChipInputSeparatorKeyCodes]="separators" [readonly]="true"
              [required]="field.required" autocomplete="off" (click)="openCategoryTreeDialog()" />
            </mat-chip-grid>
            @if (field.hint) {
              <mat-hint>{{ field.hint | localize }}</mat-hint>
            }
            @if (!field.readonly && field.control.errors) {
              <mat-error>
                @if (field.control.hasError('required')) {
                  {{ 'errorRequiredField' | transloco }}
                }
                @if (field.control.hasError('minlength')) {
                  {{ 'errorMinLengthField' | transloco:{ requiredLength:
                  field.control.errors.minlength.requiredLength } }}
                }
                @if (field.control.hasError('maxlength')) {
                  {{ 'errorMaxLengthField' | transloco:{ requiredLength:
                  field.control.errors.maxlength.requiredLength } }}
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    }
  } @else {
    {{ displayedValue }}
  }

